import { render } from "./CompaniesFooter.vue?vue&type=template&id=7cb514ce&scoped=true"
import script from "./CompaniesFooter.vue?vue&type=script&lang=js"
export * from "./CompaniesFooter.vue?vue&type=script&lang=js"

import "./CompaniesFooter.vue?vue&type=style&index=0&id=7cb514ce&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb514ce"]])

export default __exports__